import type { BreadcrumbLink } from './PageLayout/types';

export const hasBackButton = (links: BreadcrumbLink[]): boolean =>
    links.length > 1 && Boolean(links[links.length - 2].url);
